module.exports = __webpack_public_path__ + "static/media/equals.a820a81a.svg";